import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { selectUserById } from "../../../../store/roblox/usersSlice";
import { selectSkinById } from "../../../../store/roblox/skinsSlice";

import { RightSidebar } from "../../../_partials/Layout";
import Meta from "../../Users/_partials/_Meta";
import { EntityId } from "@reduxjs/toolkit";

const _SidebarShow = ({ id }: { id: EntityId | undefined }) => {
  const skin = useAppSelector(state => id ? selectSkinById(state, id) : undefined);
  const user = useAppSelector(state => skin?.user_id ? selectUserById(state, skin?.user_id) : undefined);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {user && <h6 className="v-content-label o-sm">User</h6>}
      {<Meta user={user} />}
    </RightSidebar>
  )
}

export default _SidebarShow;
